import React from 'react';
import PropTypes from 'prop-types';

/**
 * Generic summary box for Test Catalog page.
 * Shows total tests and counts per testTool.
 */
export default function SummaryBox({ tests, title, loading }) {
  const total = tests.length;
  const counts = tests.reduce((acc, { testTool }) => {
    const tool = testTool || 'Unknown';
    acc[tool] = (acc[tool] || 0) + 1;
    return acc;
  }, {});
  const toolEntries = Object.entries(counts);

  return (
    <div className="summary-box">
      <div className="summary-title">{title}</div>
      {loading ? (
        <div className="summary-total">Loading summary...</div>
      ) : (
        <>
          <div className="summary-total">Total tests: {total}</div>
          <div className="tool-counts">
            {toolEntries.map(([tool, count]) => (
              <span key={tool} className="tool-item">
                {tool}: {count}
              </span>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

SummaryBox.propTypes = {
  tests: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  loading: PropTypes.bool,
};

SummaryBox.defaultProps = {
  loading: false,
};
